module.exports = __webpack_public_path__ + "static/img/shouhoutongzhi_wenshenshi.8c11800.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shouhoutongzhi_wenshenshi.png
// module id = 390
// module chunks = 31